<template>
    <section id="prizes" class="prizes" aria-labelledby="prizes-title">
        <div class="prizes-inner">
            <header class="prizes-header">
                <h2 id="prizes-title">NAGRODY</h2>
                <span aria-hidden="true"></span>
            </header>

            <div class="prizes-grid">
                <img
                    class="prizes-car"
                    src="@/assets/images/prizes/bolid.webp"
                    alt="Bolid Ferrari"
                >

                <div class="prizes-trip">
                    <h3>WYJAZD DO WŁOCH<br>NA MONZĘ 2026</h3>
                    <p class="prizes-trip-subtitle">DLA 2 OSÓB</p>

                    <ul class="prizes-list">
                        <li>
                            <span class="prizes-check" aria-hidden="true"></span>
                            <span>
                                <strong>10 000 zł</strong>
                                <small>na pokrycie<br>kosztów podróży</small>
                            </span>
                        </li>
                        <li>
                            <span class="prizes-check" aria-hidden="true"></span>
                            <span>bilety VIP na wyścig</span>
                        </li>
                    </ul>
                </div>

                <div class="prizes-merch">
                    <img
                        class="prizes-hoodie"
                        src="@/assets/images/prizes/bluza.webp"
                        alt="Bluza Scuderia Ferrari HP"
                    >
                    <div class="prizes-merch-copy">
                        <strong>100 <em>x</em></strong>
                        <p>Gadżety Scuderia Ferrari HP</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.prizes {
    overflow: hidden;
    background: var(--color-primary);
    color: #fff;
}

.prizes-inner {
    min-height: 1057px;
    max-width: 1920px;
    margin: 0 auto;
    padding: 136px 24px 112px;
}

.prizes-header {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.prizes-header h2 {
    margin: 0;
    font-size: 62px;
    font-weight: 300;
    line-height: 1;
}

.prizes-header span {
    display: block;
    width: 206px;
    height: 1px;
    margin-top: 31px;
    background: rgba(255, 255, 255, 0.6);
}

.prizes-grid {
    display: grid;
    grid-template-columns: 430px 545px minmax(0, 1fr);
    align-items: center;
    column-gap: 58px;
    width: min(100%, 1510px);
    margin: 59px auto 0;
}

.prizes-car {
    display: block;
    width: 426px;
    max-width: 100%;
}

.prizes-trip {
    padding-top: 3px;
}

.prizes-trip h3 {
    margin: 0;
    font-size: 52px;
    font-weight: 700;
    line-height: 1.13;
}

.prizes-trip-subtitle {
    margin: 6px 0 0;
    font-size: 40px;
    font-weight: 300;
    line-height: 1;
}

.prizes-list {
    display: flex;
    flex-direction: column;
    gap: 23px;
    margin: 37px 0 0;
    padding: 0;
    list-style: none;
}

.prizes-list li {
    display: flex;
    align-items: flex-start;
    gap: 23px;
    font-size: 32px;
    font-weight: 300;
    line-height: 1.15;
}

.prizes-check {
    position: relative;
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    margin-top: 6px;
    border: 3px solid #f20d26;
    border-radius: 50%;
}

.prizes-check::after {
    position: absolute;
    top: 6px;
    left: 10px;
    width: 6px;
    height: 12px;
    border-right: 2px solid #f20d26;
    border-bottom: 2px solid #f20d26;
    content: "";
    transform: rotate(45deg);
}

.prizes-list strong {
    display: block;
    font-size: 54px;
    font-weight: 300;
    line-height: 1;
}

.prizes-list small {
    display: block;
    margin-top: 4px;
    font-size: 32px;
    font-weight: 300;
    line-height: 1.1;
}

.prizes-merch {
    align-self: center;
    padding-top: 3px;
}

.prizes-hoodie {
    display: block;
    width: 380px;
    max-width: 100%;
    margin: 0 auto;
}

.prizes-merch-copy {
    width: 100%;
    margin-top: -33px;
}

.prizes-merch-copy strong {
    display: block;
    font-size: 62px;
    font-weight: 300;
    line-height: 1;
}

.prizes-merch-copy em {
    color: #f20d26;
    font-size: 50px;
    font-style: normal;
}

.prizes-merch-copy p {
    margin: 6px 0 0;
    font-size: 40px;
    font-weight: 300;
    line-height: 1.05;
    white-space: nowrap;
}

@media only screen and (min-width: 1280px) and (max-width: 1759px) {
    .prizes-inner {
        padding-right: 40px;
        padding-left: 40px;
    }

    .prizes-grid {
        grid-template-columns: minmax(320px, 0.9fr) minmax(440px, 1.15fr) minmax(330px, 0.95fr);
        column-gap: clamp(28px, 3vw, 48px);
    }

    .prizes-car {
        width: min(100%, 426px);
        justify-self: center;
    }

    .prizes-trip h3 {
        font-size: clamp(42px, 3.1vw, 50px);
    }

    .prizes-trip-subtitle {
        font-size: clamp(34px, 2.5vw, 40px);
    }

    .prizes-list li,
    .prizes-list small {
        font-size: clamp(27px, 1.9vw, 31px);
    }

    .prizes-list strong {
        font-size: clamp(48px, 3.35vw, 54px);
    }

    .prizes-hoodie {
        width: min(100%, 360px);
    }

    .prizes-merch-copy {
        width: max-content;
        max-width: 100%;
        margin: -26px auto 0;
    }

    .prizes-merch-copy strong {
        font-size: clamp(52px, 3.6vw, 60px);
    }

    .prizes-merch-copy em {
        font-size: clamp(43px, 3vw, 49px);
    }

    .prizes-merch-copy p {
        font-size: clamp(29px, 2.15vw, 37px);
    }
}

@media only screen and (min-width: 640px) and (max-width: 1279px) {
    .prizes-inner {
        min-height: auto;
        padding: 86px 40px 100px;
    }

    .prizes-grid {
        grid-template-columns: minmax(260px, 0.9fr) minmax(330px, 1.1fr);
        gap: 50px 32px;
        max-width: 880px;
    }

    .prizes-car {
        width: 360px;
        justify-self: center;
    }

    .prizes-trip h3 {
        font-size: 42px;
    }

    .prizes-trip-subtitle {
        font-size: 34px;
    }

    .prizes-list li,
    .prizes-list small {
        font-size: 27px;
    }

    .prizes-list strong {
        font-size: 46px;
    }

    .prizes-merch {
        grid-column: 1 / -1;
        width: 500px;
        max-width: 100%;
        justify-self: center;
    }
}

@media only screen and (max-width: 639px) {
    .prizes-inner {
        min-height: 1358px;
        padding: 37px 29px 56px;
    }

    .prizes-header h2 {
        font-size: 39px;
    }

    .prizes-header span {
        width: 108px;
        margin-top: 19px;
    }

    .prizes-grid {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        margin-top: 52px;
    }

    .prizes-car {
        width: 246px;
        margin: 0 auto;
    }

    .prizes-trip {
        margin-top: 39px;
        padding: 0;
    }

    .prizes-trip h3 {
        font-size: 34px;
        line-height: 1.13;
    }

    .prizes-trip-subtitle {
        margin-top: 3px;
        font-size: 32px;
    }

    .prizes-list {
        gap: 20px;
        margin-top: 21px;
    }

    .prizes-list li {
        gap: 16px;
        font-size: 24px;
    }

    .prizes-check {
        width: 24px;
        height: 24px;
        margin-top: 4px;
        border-width: 2px;
    }

    .prizes-check::after {
        top: 4px;
        left: 8px;
        width: 5px;
        height: 10px;
    }

    .prizes-list strong {
        font-size: 40px;
    }

    .prizes-list small {
        margin-top: 2px;
        font-size: 24px;
    }

    .prizes-merch {
        margin-top: 40px;
        padding: 0;
    }

    .prizes-hoodie {
        width: 242px;
    }

    .prizes-merch-copy {
        margin-top: -2px;
        padding-left: 10px;
    }

    .prizes-merch-copy strong {
        font-size: 40px;
    }

    .prizes-merch-copy em {
        font-size: 33px;
    }

    .prizes-merch-copy p {
        max-width: 290px;
        margin-top: 4px;
        font-size: 27px;
        line-height: 1.15;
        white-space: normal;
    }
}
</style>
